import { defineStore } from 'pinia'
import { useApi } from '@provise/composables/api'
import { commons } from '@provise/lib/transformer'
import { ref } from 'vue'

export const useComplaintStore = defineStore('complaint', () => {
  const model = ref({})
  const query = ref({})

  const { refresh: doFetch } = useApi({
    url: 'complaints',
    query,
    watch: query,
    model,
    immediate: false,
    pick: d => {
      d.data = d.data.map(d => {
        d.medicineLabel = commons.medicineLabel(d.medicine)
        d.categoryLabel = requestCategoryLabel(d)
        d.overdue = false

        if (d.current_sla) {
          const fmt = 'yyyy.MM.dd HH:mm'
          d.sla_date_finish = commons.dateLocal(d.current_sla.date_finish)
          if (
            commons.dateLocal(d.current_sla.date_finish, fmt) <
              commons.dateLocal(new Date(), fmt) &&
            !['closed', 'done'].includes(d.status.key)
          )
            d.overdue = true
        }

        return d
      })
      return d
    },
  })
  return { model, query, doFetch }
})

function requestCategoryLabel(d) {
  let cat = d.request_category || {}
  return cat.parent ? `${cat.parent.name} / ${cat.name}` : cat.name
}
